import { render } from "./MBFSelect.vue?vue&type=template&id=323ecc85"
import script from "./MBFSelect.vue?vue&type=script&lang=js"
export * from "./MBFSelect.vue?vue&type=script&lang=js"

import "./MBFSelect.vue?vue&type=style&index=0&id=323ecc85&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__